import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import { REGISTRATION_URL } from '@/constants/routes';
import { TranslationNamespace } from '@/i18n';

import styles from './RegisterBanner.module.scss';

export const RegisterBanner = () => {
	const { t } = useTranslation(TranslationNamespace.WarehouseSearch);
	return (
		<section className={styles.banner}>
			<div className={styles.content}>
				<div className={styles.title}>
					{t('storage-page.register-to-submit-warehouse-requests')}
				</div>
				<p className={styles.description}>
					{t('storage-page.warehouse-requests-available-after-registration')}
				</p>
				<Button type="primary" className={styles.button} href={REGISTRATION_URL}>
					{t('register')}
				</Button>
			</div>
		</section>
	);
};
